export default () =>
  !!(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement &&
    !navigator?.userAgent?.includes("jsdom")
  );
